module.exports = __webpack_public_path__ + "img/envelope-square.241a48fd.svg";